import type { ReactNode } from 'react'
import React from 'react'
import { PageTitle } from './PageTitle'
import { HorizontalStack } from '@ztechapps/webui.util'
import { Col, Row, Stack } from 'react-bootstrap'

export type PageHeaderProps = PageHeaderContentProps & {
  children?: React.ReactNode
  className?: string
}

export const PageHeader = ({ title, description, actions, breadcrumbs, children, className, siteName }: PageHeaderProps) => {
  children = children ?? <PageHeaderContent title={title} description={description} actions={actions} breadcrumbs={breadcrumbs} siteName={siteName} />

  return <HorizontalStack className={`${className ?? 'justify-content-between mb-1 '} `}>{children}</HorizontalStack>
}

export type PageHeaderContentProps = {
  title?: ReactNode
  description?: string
  actions?: React.ReactNode
  breadcrumbs?: React.ReactNode
  siteName?: string
}
export const PageHeaderContent = ({ title, description, actions, breadcrumbs, siteName }: PageHeaderContentProps) => {
  return (
    <Stack>
      <Row>
        <Col sm={12} md={6} className="align-self-center">
          <Stack>
            <div>
              {title && <PageTitle title={title} siteName={siteName} noTitleTag />}
              {description && <small>{description}</small>}
              {breadcrumbs}
            </div>
          </Stack>
        </Col>
        <Col sm={12} md={6}>
          <div>
            <HorizontalStack className="justify-content-lg-end">{actions && <div className="title-action">{actions}</div>}</HorizontalStack>
          </div>
        </Col>
      </Row>
    </Stack>
  )
}
